import React from "react";
import { PageLayout } from "../components/page-layout";
import EventCalendar from "../components/events/event-calendar";

export const AllEventsPage = () => (
  <PageLayout>
    <EventCalendar />
  </PageLayout>
);
